const TreeHelper = {
  DataModify: (baseData) => {
    let data = [];

    for (let i = 0; i < baseData.length; i++) {
      let obj = { ...baseData[i] };

      obj["index"] = i;
      data.push(obj);
    }
    let finalList = [];

    //unique list of elements
    let uniqueList = (data, name) => {
      return data
        .map((e) => e[name])
        .filter((v, i, self) => {
          return self.indexOf(v) === i;
        });
    };
    //unique asset class
    const asset_class_list = uniqueList(data, "asset_class");

    // unique classification
    const classification_list = uniqueList(data, "classification");

    //final data

    const finalData = asset_class_list.map(function (el) {
      let obj = {};
      var filterFun = (el) => {
        let inner_obj = {};
        let filteredData = data.filter((e) => e.asset_class == el);

        let unq_list = uniqueList(filteredData, "classification");

        unq_list.map(function (element) {
          let classiFicationFilterData = filteredData.filter(
            (list) => list.classification == element
          );

          let styleFilter_List = uniqueList(classiFicationFilterData, "style");

          inner_obj[element] = styleFilter_List.map((data) => {
            let styleObj = {};

            styleObj[data] = classiFicationFilterData.filter(
              (e) => e.style == data
            );

            styleObj[data].sort((a, b) =>
              a.fund_name.toUpperCase() > b.fund_name.toUpperCase()
                ? 1
                : b.fund_name.toUpperCase() > a.fund_name.toUpperCase()
                ? -1
                : 0
            );

            return styleObj;
          });
        });

        return inner_obj;
      };

      obj[el] = filterFun(el);

      return obj;
    });

    return finalData;
  },
};

export default TreeHelper;



// WEBPACK FOOTER //
// ./src/components/pages/MyUniverse/treeTable/TreeHelper.js